import Model from "@/models/Model";

export default class Assignee extends Model {
    resource() {
        return "assignees";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }
}
